import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { location } from "../../../../api";
import NormalInput from "../../../../components/form/HorizontalNormalInput";
import { Card, CardBody, CardHeader } from "../../../../components/card/card";
function ModalChangePlant({
  openModal,
  setOpenModal,
  onSuccess,
  selected,
  title,
  onSubmitted,
  editMode,
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const { config } = useAuth();
  const [dataToSend, setDataToSend] = useState({
    location_name: "",
    picture_url: "",
    location_address: "",
    contact_person: "",
    contact_number: "",
    contact_email: "",
  });
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  async function getRecord() {
    if (editMode) {
      setPreview(renderImage(`/machine/attachment/${selected.picture_url}`));
      setDataToSend((prevData) => ({
        ...prevData,
        location_name: selected.location_name,
        picture_url: selected.picture_url,
        location_address: selected.location_address,
        contact_person: selected.contact_person,
        contact_number: selected.contact_number,
        contact_email: selected.contact_email,
      }));
    } else {
      setPreview("");
      setDataToSend((prevData) => ({
        ...prevData,
        location_name: "",
        picture_url: "",
        location_address: "",
        contact_person: "",
        contact_number: "",
        contact_email: "",
      }));
    }
  }
  useEffect(() => {
    getRecord();
  }, [selected]);

  useEffect(() => {
    getRecord();
  }, [editMode]);
  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);
  const onSelectFile = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }
    setSelectedFile(e.target.files[0]);
  };

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleEdit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      hasil.location_id = selected.id;
      hasil.contact_number = hasil.contact_number?.toString();
      delete hasil.parent_id;
      //console.log({ selected });
      const res = await location.update(selected.id, hasil, selectedFile);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          onSubmitted();
          setOpenModal(false);
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  const clearFields = () => {
    setDataToSend({
      location_name: "",
      picture_url: "",
      location_address: "",
      parent_location_id: "",
      contact_person: "",
      contact_number: "",
      contact_email: "",
    });
    setPreview("");
    setSelectedFile(null);
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      delete hasil.parent_id;
      hasil.contact_number = hasil.contact_number?.toString();
      const res = await location.create(hasil, selectedFile);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          onSubmitted();
          setOpenModal(false);
          clearFields();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  return (
    <ConfirmationDlg
      open={openModal}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={editMode ? handleEdit : handleSubmit}
      onClose={handleClose}
    >
      <h4>{config?.location_wording.split(",")[0]}</h4>
      <div className="my-2">
        <div className="row">
          <div className="col-md-4 position-relative">
            <Card>
              <CardHeader>Photo</CardHeader>
              <CardBody>
                <label htmlFor="files">
                  {preview ? (
                    <>
                      <img src={preview} className="img-thumbnail" alt="" />
                      <div
                        style={{
                          textAlign: "center",
                          cursor: "pointer",
                          marginTop: "5px",
                        }}
                      >
                        Change Photo <i className="fa fa-camera"></i>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          minHeight: "150px",
                          alignItems: "center",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <i className="fa fa-camera"></i>
                        <div>Add a Photo</div>
                      </div>
                    </>
                  )}
                </label>
                <input
                  id="files"
                  onChange={onSelectFile}
                  style={{ visibility: "hidden", position: "absolute" }}
                  type="file"
                  accept="image/png, image/jpeg"
                />
              </CardBody>
            </Card>
          </div>
          <div className="col-md-8">
            <NormalInput
              full={true}
              required={true}
              placeholder={`Enter ${
                config?.location_wording.split(",")[0]
              } Name`}
              value={dataToSend["location_name"]}
              label={config?.location_wording.split(",")[0]}
              onchange={handleOnchange}
              name="location_name"
            />
            <NormalInput
              full={true}
              required={true}
              placeholder={`Enter ${
                config?.location_wording.split(",")[0]
              } Address`}
              value={dataToSend["location_address"]}
              label="Address"
              onchange={handleOnchange}
              name="location_address"
            />

            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Name of Contact Person"}
              value={dataToSend["contact_person"]}
              label="Contact Person"
              onchange={handleOnchange}
              name="contact_person"
            />

            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Contact Number"}
              value={dataToSend["contact_number"]}
              label="Contact Number"
              onchange={handleOnchange}
              name="contact_number"
            />
            <NormalInput
              full={true}
              required={false}
              placeholder={"Enter Email"}
              value={dataToSend["contact_email"]}
              label="Email"
              onchange={handleOnchange}
              name="contact_email"
            />
          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangePlant;
